import { forwardRef, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { Grid } from '@material-ui/core'
import { useEffect } from 'react'
import ArquivoBox from '../../../components/data_display/ArquivoBox'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function Arquivos({ arquivos, setArquivos }) {
  const [loading, setLoading] = useState(false)
  const [arquivosPrincipal, setArquivosPrincipal] = useState([])
  const [arquivosAnexosPrincipal, setArquivosAnexosPrincipal] = useState([])
  const [arquivosReciboAceite, setArquivosReciboAceite] = useState([])

  const [arquivosResposta, setArquivosResposta] = useState([])

  const handleFecharArquivos = () => {
    setArquivos({
      open: false,
      arquivos: [],
      respostas: [],
      ultimaResposta: null,
      aplicaScroll: false
    })

    if (!loading) {
      setArquivos({
        open: false,
        arquivos: [],
        respostas: [],
        ultimaResposta: null,
        aplicaScroll: false
      })
    }
  }

  useEffect(() => {
    setArquivosPrincipal(arquivos.arquivos.filter((item) => { return item.tipoArquivo === 0; }))
    setArquivosAnexosPrincipal(arquivos.arquivos.filter((item) => { return item.tipoArquivo === 1; }))
    setArquivosReciboAceite(arquivos.arquivos.filter((item) => { return item.tipoArquivo === 2; }))
    setArquivosResposta(arquivos.respostas)
  }, [arquivos.open])

  useEffect(() => {
    if (arquivos.aplicaScroll) {
      const element = document.getElementById('last-report-refuse');
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [arquivosResposta])

  return (
    <Dialog
      open={arquivos.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleFecharArquivos}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      id="dialog-padrao"
    >
      <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Arquivos da Comunicação</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {arquivosPrincipal &&
              arquivosPrincipal.length > 0 &&
              <ArquivoBox
                arquivos={arquivosPrincipal}
                titulo="Documento Principal" />
            }

            {arquivosAnexosPrincipal &&
              arquivosAnexosPrincipal.length > 0 &&
              <ArquivoBox
                arquivos={arquivosAnexosPrincipal}
                titulo="Arquivos Anexos Comunicação" />
            }

            {arquivosReciboAceite &&
              arquivosReciboAceite.length > 0 &&
              <ArquivoBox
                arquivos={arquivosReciboAceite}
                titulo="Recibo de Aceite" />
            }

            {arquivos.respostas && arquivos.respostas.map((item, index) => {
              if (arquivos.ultimaResposta != null &&
                arquivos.ultimaResposta.situacao === 3 &&
                arquivos.ultimaResposta.id === item.id) {
                return <>
                  <span id="last-report-refuse" />
                  <ArquivoBox
                    arquivos={item.arquivos}
                    titulo={'Documentos Resposta de: ' + item.dataEnvioCompleta}
                    motivoRecusa={item.motivoRecusa}
                    chancela={item.chancela}
                  />
                </>
              }

              return <ArquivoBox
                arquivos={item.arquivos}
                titulo={'Documentos Resposta de: ' + item.dataEnvioCompleta}
                motivoRecusa={item.motivoRecusa}
                chancela={item.chancela}
              />
            })}

          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleFecharArquivos} className="bg-alternativo-4 txt-alternativo-3" disabled={loading}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  )
}